/*
	The collection grid picks which cards draw its column rule with :nth-child,
	which assumes every card fills exactly one column. A promo card can span two
	or three, so the count drifts and the rule lands on cards that are not
	actually at the end of a row. "Last card in the visual row" cannot be
	expressed as a selector once spans exist, so it is measured here and written
	back as data-row-end for section-promo-cards.css to style.

	Only grids that render a promo card carry the --has-promo class, so an
	ordinary collection never reaches any of this.
*/
(function () {
	const observed = new WeakSet();
	let frame = null;

	function measure() {
		frame = null;

		document.querySelectorAll('.collection-product-list--has-promo').forEach((list) => {
			const cards = Array.from(list.children);
			if (cards.length === 0) return;

			// Every offset is read before anything is written, so a grid of any
			// size costs a single layout pass rather than one per card.
			const boxes = cards.map((card) => ({
				card: card,
				top: card.offsetTop,
				right: card.offsetLeft + card.offsetWidth,
			}));

			// The grid packs densely, so a card can sit earlier on screen than it
			// does in the markup. The card ending a row is therefore the one
			// reaching furthest right on that row, not the last one written.
			const rowEnds = new Map();
			boxes.forEach((box) => {
				const current = rowEnds.get(box.top);
				if (current === undefined || box.right > current.right) rowEnds.set(box.top, box);
			});

			// A row that stops short of the list's right edge (the last row of an
			// odd count) keeps its column rule, so it still closes the last card.
			const listRight = list.clientWidth;
			boxes.forEach((box) => {
				const endsRow = rowEnds.get(box.top) === box && box.right >= listRight - 2;
				box.card.toggleAttribute('data-row-end', endsRow);
			});

			list.setAttribute('data-rows-measured', '');
		});
	}

	function schedule() {
		if (frame === null) frame = requestAnimationFrame(measure);
	}

	function observe() {
		const grid = document.getElementById('ProductGridContainer');
		if (!grid || observed.has(grid)) return;
		observed.add(grid);

		// Width decides how many cards fit per row.
		new ResizeObserver(schedule).observe(grid);

		// Filtering replaces the grid's markup, load more appends to it, and the
		// per-row buttons rewrite data-productis-in-row. All three change the rows.
		new MutationObserver(schedule).observe(grid, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['data-productis-in-row'],
		});

		schedule();
	}

	observe();
	document.addEventListener('shopify:section:load', observe);
})();
